import { render, staticRenderFns } from "./approved_record_list.vue?vue&type=template&id=3c57e2e6&scoped=true"
import script from "./approved_record_list.vue?vue&type=script&lang=js"
export * from "./approved_record_list.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/financial-tools.scss?vue&type=style&index=0&id=3c57e2e6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57e2e6",
  null
  
)

export default component.exports